// extracted by mini-css-extract-plugin
module.exports = {"newMessageIndicator":"NewMessageIndicator_newMessageIndicator__2VsE1","newMessageIndicatorButton":"NewMessageIndicator_newMessageIndicatorButton__OqspV"};